import React, { useState } from "react"
import Button from "aldoo-ra/Button"
import TextField from "aldoo-ra/TextField"
import DropdownSelect from "aldoo-ra/DropdownSelect"
import Typography from "aldoo-ra/Typography"
import Tabs from "aldoo-ra/Tabs"
import { createComponent, updateComponent } from "../api"
import CheckList from "../Checks/CheckList"
import HealthGrid from "../Dashboard/HealthGrid"

const ENV_OPTIONS = [
  { value: "prod", label: "Production" },
  { value: "stage", label: "Staging" },
  { value: "dev", label: "Development" },
]

const ComponentEditor = ({ projectId, component, onClose }) => {
  const isNew = !component?._id
  const [name, setName] = useState(component?.name || "")
  const [appId, setAppId] = useState(component?.appId || "")
  const initialEnv = component?.environment || "prod"
  const [environment, setEnvironment] = useState(ENV_OPTIONS.find((o) => o.value === initialEnv) || ENV_OPTIONS[0])
  const [tags, setTags] = useState((component?.tags || []).join(", "))
  const [err, setErr] = useState(null)
  const [saved, setSaved] = useState(component?._id ? component : null)
  const [tab, setTab] = useState("checks")

  const payload = () => ({
    name,
    appId,
    environment: environment?.value || environment,
    tags: tags.split(",").map((t) => t.trim()).filter(Boolean),
  })

  const save = async () => {
    setErr(null)
    if (isNew) {
      const r = await createComponent({ projectId, ...payload() })
      if (r?.error) return setErr(r.error)
      onClose()
      return
    } else {
      const r = await updateComponent(component._id, payload())
      if (r?.error) return setErr(r.error)
      setSaved(r.component)
    }
  }

  const tabs = [
    { value: "checks", label: "Checks" },
    { value: "stats", label: "Stats" },
  ]

  return (
    <div className="space-y-6">
      {!isNew && (
        <Typography variant="admin_h3">{`Edit: ${name}`}</Typography>
      )}

      <div className="flex flex-col gap-3">
        <TextField label="Name" value={name} onChange={setName} />
        <TextField label="App ID" value={appId} onChange={setAppId} placeholderText="e.g. aldoo-meet-web-app" />
        <DropdownSelect label="Environment" value={environment} onChange={(v) => setEnvironment(v?.[0] || v)} options={ENV_OPTIONS} />

        <TextField label="Tags (optional)" value={tags} onChange={setTags} placeholderText="comma-separated" collapsible />
      </div>

      <div className="flex flex-col items-center gap-2">
        <Button onClick={save} className="px-10 py-3 text-base">{isNew ? "Create" : "Save"}</Button>
        {err && <div className="text-error text-sm">Error: {err}</div>}
      </div>

      {saved?._id && (
        <div className="border-t border-bordered pt-4 space-y-4">
          <Tabs tabs={tabs} value={tab} onChange={setTab} />
          {tab === "checks" && <CheckList componentId={saved._id} />}
          {tab === "stats" && (
            <div className="max-w-3xl">
              <HealthGrid componentId={saved._id} days={90} />
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default ComponentEditor
